import type { DefaultRoundSettings } from "Models";
import { normalize } from "normalizr";
import type {
  AppQueryConfig,
  DefaultRoundSettingsUpdateBody,
} from "QueryTypes";
import { clubhouseApiHeadersV1 } from "utils/api/apiHelper";
import { defaultRoundSettings } from "./defaultRoundSettingsSchema";
import { config } from "@/config/env";

const urls = {
  facilityDefaultRoundSettings(facilityId: string): string {
    return `${config.apiBaseUrl}/api/facilities/${facilityId}/default-round-settings`;
  },
};

export const facilityDefaultRoundSettingsQuery = (
  facilityId: string,
): AppQueryConfig => ({
  url: urls.facilityDefaultRoundSettings(facilityId),
  queryKey: `facilityDefaultRoundSettings:${facilityId}`,
  options: { ...clubhouseApiHeadersV1() },
  transform: (responseJson: DefaultRoundSettings) => {
    return normalize(responseJson, defaultRoundSettings).entities;
  },
  update: {
    defaultRoundSettings: (oldValue, newValue) => ({
      ...oldValue,
      ...newValue,
    }),
  },
});

export const makeUpdateDefaultRoundSettingsMutation = (
  facilityId: string,
  body: DefaultRoundSettingsUpdateBody,
): AppQueryConfig => ({
  url: urls.facilityDefaultRoundSettings(facilityId),
  queryKey: `makeRoundConfigMutation:${facilityId}`,
  options: {
    ...clubhouseApiHeadersV1(),
    method: "PATCH",
  },
  body,
  transform: (responseJson: DefaultRoundSettings) => {
    return normalize(responseJson, defaultRoundSettings).entities;
  },
  update: {
    defaultRoundSettings: (oldValue, newValue) => ({
      ...oldValue,
      ...newValue,
    }),
  },
});
